import { DeleteOutlined, ExclamationCircleOutlined } from '@easyv/react-icons';
import { concatUrl, getAssetsPrefix } from '@/utils';
import { AssetItem } from '@/type';
import React from 'react';
import { Modal } from '@easyv/react-components';

interface UndefinedAssetProps {
  data: AssetItem;
  onDelete?: (ids: string[]) => void;
}

export function UndefinedAsset({ data, onDelete }: UndefinedAssetProps) {
  const { id, name, thumb, type } = data;

  return (
    <div key={id} className='flex items-center justify-center p-2 flex-col w-32 h-36'>
      {/* 资产背景图 */}
      <div
        style={{
          backgroundImage: thumb
            ? `url(${concatUrl(getAssetsPrefix(), thumb)})`
            : `url(${require('@/assets/img/empty_file.png')})`,
        }}
        className='relative group bg-center bg-no-repeat bg-cover w-full h-full rounded-sm'
      >
        {/* 删除图标 */}
        <div
          className='absolute items-center justify-center w-full h-full hidden group-hover:flex border border-primary rounded-sm'
          style={{
            background: 'linear-gradient(0deg, rgba(24, 27, 36, 0.35), rgba(24, 27, 36, 0.35))',
          }}
        >
          <DeleteOutlined
            type='primary'
            className='absolute top-[0.2rem] right-[0.2rem] cursor-pointer hover:text-white'
            onClick={() => {
              Modal.confirm({
                title: '确认删除',
                content: '删除后不可恢复，确认删除选中项？',
                okButtonProps: { size: 'small', status: 'danger' },
                cancelButtonProps: { size: 'small' },
                alignCenter: false,
                async onOk() {
                  onDelete?.([id]);
                },
              });
            }}
          >
            删除
          </DeleteOutlined>
        </div>
        <div>资产类型{type}未受支持</div>
      </div>
      {/* 资产下方的名字 */}
      <div className='w-full pt-2 truncate text-center' title={name}>
        {name}
      </div>
    </div>
  );
}
